import { FONT_BASE } from '../themeConstants'

export const muiComponentsMiscSurfaces = {
  MuiTab: {
    styleOverrides: {
      root: {
        fontSize: FONT_BASE,
        textTransform: 'none',
      },
    },
  },
  MuiAlert: {
    styleOverrides: {
      message: {
        fontSize: FONT_BASE,
      },
    },
  },
  MuiTableCell: {
    styleOverrides: {
      root: {
        fontSize: FONT_BASE,
      },
    },
  },
}
